import { makeStyles, tokens } from '@fluentui/react-components';
import { RecordContext, useT } from '@powerportalspro/react';
import { Timeline } from '@powerportalspro/react-fluent';
import { ACCOUNT_ID } from './DetailPageRecords';
import { DemoShowcaseHeading, DemoShowcaseLayout } from './DemoShowcaseLayout';

// The featured account's timeline — its notes and its messages with the portal user, as one list —
// beside what to try in it and what the portal leaves out. A small page size, so "Load more" has
// something to add, and a height past which the list scrolls. A signed-in visitor may write a
// message, which only they see, and save what the timeline shows as a view of their own.

const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Demos.TimelineShowcase.TimelineShowcaseMainDemo';

const useStyles = makeStyles({
  list: {
    margin: 0,
    paddingInlineStart: tokens.spacingHorizontalXL,
  },
});

// The strings are HTML, written once for both stacks.
function Item({ text }: { text: string }) {
  return <li dangerouslySetInnerHTML={{ __html: text }} />;
}

export function TimelineShowcaseMainSample() {
  const styles = useStyles();
  const t = useT();

  return (
    <DemoShowcaseLayout
      title={t(`${STRINGS_BASE}.try-title`)}
      demoShare={2}
      tips={
        <>
          <ul className={styles.list}>
            <Item text={t(`${STRINGS_BASE}.try-search`)} />
            <Item text={t(`${STRINGS_BASE}.try-more`)} />
            <Item text={t(`${STRINGS_BASE}.try-download`)} />
            <Item text={t(`${STRINGS_BASE}.try-load-more`)} />
            <Item text={t(`${STRINGS_BASE}.try-write`)} />
            <Item text={t(`${STRINGS_BASE}.try-saved-views`)} />
          </ul>

          <DemoShowcaseHeading>{t(`${STRINGS_BASE}.rules-title`)}</DemoShowcaseHeading>
          <ul className={styles.list}>
            <Item text={t(`${STRINGS_BASE}.rule-notes`)} />
            <Item text={t(`${STRINGS_BASE}.rule-messages`)} />
            <Item text={t(`${STRINGS_BASE}.rule-authors`)} />
          </ul>
        </>
      }
    >
      <RecordContext table="account" id={ACCOUNT_ID}>
        <Timeline pageSize={5} maxHeight="640px" allowFiltering allowSavedViews savedViewsKey="timeline-showcase" />
      </RecordContext>
    </DemoShowcaseLayout>
  );
}
